import styles from "../LPSForm.styles";
import {
  AppBar,
  Box,
  Button, FormControl,
  IconButton,
  MenuItem,
  Toolbar,
  Typography
} from '@mui/material';
import React from "react";
import StyledTextField from "../../../common/components/styled-components/StyledTextField";
import { Add } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import { handlePasteTypesBlock } from '../../../common/components/helpers/handlePaste';
import { StyledInputLabel, StyledSelect } from '../../../common/components/styled-components/StyledSelect';
import { SelectChangeEvent } from '@mui/material/Select';

const objectConditionOptions = [
  {
    value: "include",
    label: "include",
  },
  {
    value: "exclude",
    label: "exclude",
  },
];

const objectTypeOptions = [
  {
    value: "woonfunctie",
    label: "woonfunctie",
  },
  {
    value: "bijeenkomstfunctie",
    label: "bijeenkomstfunctie",
  },
  {
    value: "celfunctie",
    label: "celfunctie",
  },
  {
    value: "gezondheidszorgfunctie",
    label: "gezondheidszorgfunctie",
  },
  {
    value: "industriefunctie",
    label: "industriefunctie",
  },
  {
    value: "kantoorfunctie",
    label: "kantoorfunctie",
  },
  {
    value: "logiesfunctie",
    label: "logiesfunctie",
  },
  {
    value: "onderwijsfunctie",
    label: "onderwijsfunctie",
  },
  {
    value: "sportfunctie",
    label: "sportfunctie",
  },
  {
    value: "winkelfunctie",
    label: "winkelfunctie",
  },
  {
    value: "overige gebruiksfunctie",
    label: "overige gebruiksfunctie",
  },
];

const ObjectTypesBlock = ({ onChange, objectTypesRules, onAdd, onDelete }) => {
  return (
    <>
      <AppBar position="relative" sx={styles.dataBoxSecond}>
        <Toolbar sx={styles.toolBarSecond}>
          <Typography component="div" sx={styles.headerContentSecond}>
            Object type condition
          </Typography>
          <Button
            disabled={objectTypesRules.length >= 11}
            onClick={() =>
              onAdd("lpsc_object_types_rules", "lpsc_object_types_rules")
            }
          >
            <Add sx={{ color: "white" }} />
          </Button>
        </Toolbar>
      </AppBar>
      <Box sx={styles.fieldHolderSecond}>
        {objectTypesRules.length > 0 &&
          objectTypesRules.map(({ variable, condition, unit_size }, index: number) => (
            <Box sx={styles.fieldBlockSecond} key={index}>
              <FormControl
                fullWidth
                margin="dense"
              >
                <StyledInputLabel
                  id="select-variable-object-types-label"
                  htmlFor="select-variable-object-types-input"
                  sx={{
                    fontSize: {
                      xs: "12px",
                      sm: "14px",
                      md: "1rem",
                    }
                  }}
                >
                  Variable
                </StyledInputLabel>
                <StyledSelect
                  labelId="select-variable-object-types-label"
                  id="select-variable-object-types"
                  name="selectVariableObjectTypes"
                  value={variable || ""}
                  label="Variable"
                  onChange={(event: SelectChangeEvent) =>  onChange(
                    "lpsc_object_types_rules",
                    "variable",
                    event,
                    index
                  )}
                  sx={styles.inputTextField}
                  inputProps={{
                    id: 'select-variable-object-types-input',
                  }}
                >
                  {objectConditionOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </StyledSelect>
              </FormControl>
              <FormControl
                fullWidth
                margin="dense"
              >
                <StyledInputLabel
                  id="select-condition-object-types-label"
                  htmlFor="select-condition-object-types-input"
                  sx={{
                    fontSize: {
                      xs: "12px",
                      sm: "14px",
                      md: "1rem",
                    }
                  }}
                >
                  Condition
                </StyledInputLabel>
                <StyledSelect
                  labelId="select-condition-object-types-label"
                  id="select-condition-object-types"
                  name="selectConditionObjectTypes"
                  value={condition || ""}
                  label="Condition"
                  onChange={(event: SelectChangeEvent) =>  onChange(
                    "lpsc_object_types_rules",
                    "condition",
                    event,
                    index
                  )}
                  sx={styles.inputTextField}
                  inputProps={{
                    id: 'select-condition-object-types-input',
                  }}
                >
                  {objectTypeOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </StyledSelect>
              </FormControl>
              <StyledTextField
                fullWidth
                label="Unit size m2"
                sx={styles.inputTextField}
                slotProps={{
                  inputLabel: {
                    sx: {
                      fontSize: {
                        xs: "12px",
                        sm: "14px",
                        md: "1rem",
                      },
                    },
                  },
                  htmlInput: {
                    min: 0,
                    pattern: "[0-9]*",
                  },
                }}
                margin="dense"
                type="number"
                onKeyDown={(e) => {
                  if (e.key === "e" || e.key === "E" || e.key === "-" || e.key === "+") {
                    e.preventDefault()
                  }
                }}
                onChange={(e) =>
                  onChange("lpsc_object_types_rules", "unit_size", e, index)
                }
                onPaste={handlePasteTypesBlock}
                value={unit_size || ""}
              />
              <IconButton
                sx={{
                  color: "#B4CEE5",
                  fontSize: {
                    xs: "medium",
                    sm: "medium",
                    md: "24px",
                  },
                }}
                onClick={() =>
                  onDelete(
                    "lpsc_object_types_rules",
                    "lpsc_object_types_rules",
                    index
                  )
                }
                aria-label="Delete"
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Box>
          ))}
      </Box>
    </>
  );
};

export default ObjectTypesBlock;
